<template>
  <Icon>
    <svg slot="svg" width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M20.33325,2 C21.24975,2 22,2.75025 22,3.66675 L22,9.5 C22,10.417 21.24975,11.16675 20.33325,11.16675 L3.66675,11.16675 C2.75025,11.16675 2,10.417 2,9.5 L2,3.66675 C2,2.75025 2.75025,2 3.66675,2 L20.33325,2 Z M20.33325,9.5 L20.33325,3.66675 L3.66675,3.66675 L3.66675,9.5 L5.33325,9.5 L5.33325,5.33325 L7,5.33325 L7,9.5 L8.25,9.5 L8.25,5.33325 L9.91675,5.33325 L9.91675,9.5 L20.33325,9.5 Z M20.33325,12.83325 C21.24975,12.83325 22,13.5835 22,14.5 L22,20.33325 C22,21.24975 21.24975,22 20.33325,22 L3.66675,22 C2.75025,22 2,21.24975 2,20.33325 L2,14.5 C2,13.5835 2.75025,12.83325 3.66675,12.83325 L20.33325,12.83325 Z M20.33325,20.33325 L20.33325,14.5 L3.66675,14.5 L3.66675,20.33325 L5.33325,20.33325 L5.33325,16.1665 L7,16.1665 L7,20.33325 L8.25,20.33325 L8.25,16.1665 L9.91675,16.1665 L9.91675,20.33325 L20.33325,20.33325 Z" id="path-1-servers"></path>
      </defs>
      <g id="blocks/menu" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-18.000000, -59.000000)">
        <g id="menu">
          <g id="Stacked-Group" transform="translate(16.000000, 16.000000)">
            <g id="menu/item-copy-5" transform="translate(0.000000, 41.000000)">
              <g id="icons/menu_serwery">
                <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
                <mask id="mask-2-servers" fill="white">
                  <use xlink:href="#path-1-servers"></use>
                </mask>
                <use id="Combined-Shape" fill="#43CEA2" fill-rule="nonzero" xlink:href="#path-1-servers"></use>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsServerIcon",
  components: {
    Icon
  },
  extends: Icon
};
</script>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-server-icon.vue